module.exports = __webpack_public_path__ + "0644af995239eeff1579335138b059c5.svg";